import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import SelectSearch, { OptionItem } from "src/components/SelectSearch";
import { FormLabel } from "src/components/atoms/FormLabel";
import { InputRow } from "../styles";
import { DynamicDropdown, DynamicFieldProps } from "../types";
import { useDynamicDropdownData } from "src/hooks/useDynamicDropdownData";

export const DynamicDropdownField = ({ dynamicField }: DynamicFieldProps) => {
  const { control } = useFormContext();
  const dropdown = dynamicField.dropdown as DynamicDropdown;

  // Fetch dynamic data if dataFetch is configured
  const { dropdownOptions } = useDynamicDropdownData(dropdown?.dataFetch ? { id: dropdown.dataFetch.id } : undefined);

  const prepareDropDownValues = (): OptionItem[] => {
    // Use dynamic data if available, otherwise fall back to static options
    const options = dropdownOptions.length > 0 ? dropdownOptions : (dropdown?.options ?? []);
    return options.map((option) => ({
      id: option.value,
      value: option.label,
    }));
  };

  return (
    <InputRow>
      <FormLabel htmlFor={dynamicField.id} required={dynamicField.rules?.required}>
        {dynamicField.label}:
      </FormLabel>
      <Controller
        control={control}
        name={dynamicField.id}
        rules={dynamicField.rules}
        defaultValue={dynamicField.defaultValue}
        render={({ field: { name, value, onChange, ref }, fieldState: { error } }) => (
          <SelectSearch
            id={dynamicField.id}
            options={prepareDropDownValues()}
            defaultValue={value}
            placeholder={dropdown?.placeholder ?? ""}
            name={name}
            onChange={(option) => onChange(option.id)}
            ref={ref}
            error={error}
          />
        )}
      />
    </InputRow>
  );
};
